import React from 'react'
import { useTranslation } from 'next-i18next'
import { ProfileDto } from '~/modules/Profile/ProfileDto'
import styles from './index.module.scss'

interface BiographyProps {
  profile: ProfileDto
}

export const Biography: React.FC<BiographyProps> = ({ profile }) => {
  const { t } = useTranslation('user_gallery')

  if (!profile.bio) return null

  return (
    <div className={ styles.bio__container }>
      <p className={ styles.bio__label }>
        { t('biography') }
      </p>

      <p className={ styles.bio__content }>
        { profile.bio }
      </p>
    </div>
  )
}
